const normalizeAppValue = (value) => {
  if (value instanceof Date) {
    return value.toISOString();
  }

  if (Array.isArray(value)) {
    return value.map(normalizeAppValue);
  }

  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        const normalizedValue = normalizeAppValue(value[key]);
        if (normalizedValue !== undefined) {
          result[key] = normalizedValue;
        }
        return result;
      }, {});
  }

  return value;
};

export const areAppValuesEqual = (initialValue, currentValue) =>
  JSON.stringify(normalizeAppValue(initialValue)) ===
  JSON.stringify(normalizeAppValue(currentValue));

export const hasAppValueChanged = (initialValue, currentValue) =>
  !areAppValuesEqual(initialValue, currentValue);

